import { atom } from 'nanostores';
import type { RawPortableText } from '../types/types';

export type NoficationContent =
  | string
  | {
      portableText: RawPortableText;
      fileUrl?: string;
    };

export const $notificationContent = atom<NoficationContent | null>(null);

export const showNotification = (notificationContent: NoficationContent) => {
  $notificationContent.set(notificationContent);

  setTimeout(() => {
    $notificationContent.set(null);
  }, 5000);
};
